import { PersonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const GetPersonOrgRoleFilteredData = (personId, orgRoleId, state, setState) => {
  if (state.isArrayLoading !== true && orgRoleId && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const personIdForUrl = personId ? encodeURIComponent(personId) : 0;
    const orgRoleIdForUrl = orgRoleId ? encodeURIComponent(orgRoleId) : 'NaN';

    const url = `/Person/${personIdForUrl}/orgRoles/${orgRoleIdForUrl}/orgUnitId`;
    PersonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetPersonOrgRoleFilteredData;